<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-[70]" @close="$emit('update:open', false)">
            <div class="fixed inset-0" />

            <div class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden">
                    <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <TransitionChild
                            as="template"
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enter-from="translate-x-full"
                            enter-to="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leave-from="translate-x-0"
                            leave-to="translate-x-full">
                            <DialogPanel class="pointer-events-auto w-screen max-w-[460px] ">
                                <div class="m-4 flex h-[calc(100%-32px)] w-[432px] flex-col rounded-lg bg-white py-6 shadow-xl overflow-hidden">
                                    <div class="px-4 sm:px-6 pb-4">
                                        <div class="flex items-start justify-between">
                                            <DialogTitle class="text-xl font-semibold leading-6 text-gray-900">
                                               Manual
                                            </DialogTitle>
                                            <div class="ml-3 flex h-7 items-center">
                                                <button @click="$emit('update:open', false)"
                                                        type="button"
                                                        class="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none ">
                                                    <span class="absolute -inset-2.5" />
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="w-[18px] h-[18px] text-[#171717]" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-1 flex-col gap-3 p-4 min-h-0 overflow-y-auto ">
                                        <!-- Core HR -->
                                        <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                                            <div
                                                class="group flex items-center justify-between px-4 py-4 cursor-pointer transition-colors"
                                                @click="toggle('coreHR')"
                                            >
                                                <div class="flex items-center gap-2">
                                                    <span class="text-[20px] font-bold text-blue-600">Core HR</span>
                                                </div>
                                                <svg
                                                :class="[
                                                        openSections.coreHR
                                                            ? 'rotate-180'
                                                            : 'rotate-0'
                                                    ]"
                                                    class="transition-transform duration-300"
                                                    width="10"
                                                    height="8"
                                                    viewBox="0 0 10 8"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                    <path d="M0 0L5 7.12L10 0H0Z" fill="#AAAAAA"/>
                                                </svg>   
                                            </div>
                                            <transition name="slide">                                                         
                                                <div v-if="openSections.coreHR"
                                                    class="custom-scroll px-4 py-4 pt-0 overflow-y-auto overflow-x-hidden h-[calc(100vh-260px)]"
                                                >
                                                    <div class="border-t border-[#DDD]">
                                                        <div v-if="openSections.coreHR" class="py-4 pt-6">
                                                            <!-- User Manuals -->
                                                            <div class="flex items-center gap-2 mb-3">                                                  
                                                                <img src="@/assets/img/manaul-blue.svg" width="16" height="16" />
                                                                <span class="font-semibold text-base leading-[22px] text-[#112FBA] font-['Inter']">User Manuals</span>
                                                            </div>
                                                            <!-- Manual 목록 -->
                                                            <div class="flex flex-col gap-2">
                                                                <!-- HRnFLEX Manual -->
                                                                <div class="flex items-center justify-between w-[364px] h-14 p-3 gap-2 bg-[#F4F4F4] rounded-xl">
                                                                    <div class="flex items-center gap-2">
                                                                        <img src="@/assets/img/document-gray.svg" width="24" height="24" />
                                                                        <span class="font-normal text-sm leading-5 text-[#171717] font-['Inter']">HRnFLEX Manual</span>
                                                                    </div>
                                                                    <a :href="require(`@/assets/file/HRnFLEX_CoreHR_MSS_Manual_V4.pdf.png`)"
                                                                    download="HRnFLEX_Admin_Manual.pdf"
                                                                    class="flex items-center justify-center gap-1 w-[94px] h-8 rounded-[8px] px-2 bg-[#4361EE] transition-colors text-[12px] font-medium leading-[100%] text-center text-white font-['Inter']">
                                                                        <img src="@/assets/img/download_icon.png" width="12" height="12" />
                                                                        Download
                                                                    </a>
                                                                </div>
                                                                <!-- Payroll Manual -->
                                                                <div class="flex items-center justify-between w-[364px] h-14 p-3 gap-2 bg-[#F4F4F4] rounded-xl">
                                                                    <div class="flex items-center gap-2">
                                                                        <img src="@/assets/img/document-gray.svg" width="24" height="24"  />
                                                                        <span class="font-normal text-sm leading-5 text-[#171717] font-['Inter']">Payroll Manual</span>
                                                                    </div>
                                                                    <a :href="require(`@/assets/file/HRnFLEX_Payroll_MSS Manual V3.pdf.png`)"
                                                                    download="Payroll_Manual.pdf"    
                                                                    class="flex items-center justify-center gap-1 w-[94px] h-8 rounded-[8px] px-2 bg-[#4361EE] transition-colors text-[12px] font-medium leading-[100%] text-center text-white font-['Inter']">
                                                                        <img src="@/assets/img/download_icon.png" width="12" height="12" />
                                                                        Download
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Video Tutorials -->
                                                    <div class="flex gap-2 mt-4 mb-3">
                                                        <img src="@/assets/img/video-blue.svg" width="16" height="16" />
                                                        <span class="font-semibold text-base leading-[22px] text-[#112FBA] font-['Inter']">Video Tutorials</span>
                                                    </div>
                                                    <div class="flex flex-col gap-2 pb-10">                                                         
                                                        <template v-for="(step, index) in coreVideoTutorial" :key="index">
                                                            <!-- [S] Step-->
                                                            <div 
                                                                class="flex gap-3 mb-2"
                                                                :class="step.length > 1 ? 'items-start' : 'items-center'"    
                                                            >
                                                               <span 
                                                                    class="w-14 shrink-0 text-[12px] font-semibold leading-[17px] text-[#666666] font-['Inter'] align-middle"
                                                                    :class="step.length > 1 ? 'self-start mt-2' : 'self-center'"
                                                                >
                                                                    {{ `Step${index + 1}` }}
                                                                </span>
                                                                <div class="flex flex-col gap-2">
                                                                    <template v-for="(tutorials, idx) in step" :key="idx">
                                                                        <div 
                                                                            class="flex items-center justify-between w-[296px] h-14 p-3 gap-2 rounded-xl bg-[#F4F4F4] cursor-pointer  transition-colors"
                                                                            @click="openTutorialsVideo(tutorials)"
                                                                        >
                                                                            <div class="flex items-center gap-2">                                                    
                                                                                <img src="@/assets/img/video-gray.svg" width="24" height="24" />
                                                                                <span class="font-normal text-sm leading-5 text-[#171717] font-['Inter']"> {{ tutorials.title }}</span>
                                                                            </div>
                                                                            <span class="text-blue-500 pr-2 cursor-pointer select-none">
                                                                            ▶</span>
                                                                        </div>
                                                                </template>
                                                            </div>
                                                            </div>
                                                            <!-- [E] Step -->
                                                        </template>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>

                                        <!-- Flex Rewards -->
                                        <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                                            <div
                                                class="group flex items-center justify-between px-4 py-4 cursor-pointer transition-colors"
                                                @click="toggle('flexRewards')"
                                            >
                                                <div class="flex items-center gap-2">
                                                    <span class="text-[20px] font-bold text-blue-600">Flex Rewards</span>
                                                </div>
                                                <svg
                                                    :class="[
                                                        openSections.flexRewards
                                                            ? 'rotate-180'
                                                            : 'rotate-0'
                                                    ]"                                                    
                                                    class="transition-transform duration-300 "
                                                    width="10"
                                                    height="8"
                                                    viewBox="0 0 10 8"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                    <path d="M0 0L5 7.12L10 0H0Z" fill="#AAAAAA"/>
                                                </svg>
                                            </div>
                                            <transition name="slide">
                                                <div v-if="openSections.flexRewards" 
                                                    class="custom-scroll px-4 py-4 pt-0 overflow-y-auto overflow-x-hidden h-[calc(100vh-260px)] ]" 
                                                >
                                                    <div class="border-t border-[#DDD]">
                                                        <div v-if="openSections.flexRewards" class="py-4 pt-6">
                                                            <!-- User Manuals -->
                                                            <div class="flex items-center gap-2 mb-3">                                                  
                                                                <img src="@/assets/img/manaul-blue.svg" width="16" height="16" />
                                                                <span class="font-semibold text-base leading-[22px] text-[#112FBA] font-['Inter']">User Manuals</span>
                                                            </div>
                                                            <!-- Manual 목록 -->
                                                            <div class="flex flex-col gap-2">
                                                                <!-- FlexBen Manual-->
                                                                <div class="flex items-center justify-between w-[364px] h-14 p-3 gap-2 bg-[#F4F4F4] rounded-xl">
                                                                    <div class="flex items-center gap-2">
                                                                        <img
                                                                            src="@/assets/img/document-gray.svg"
                                                                            width="24"
                                                                            height="24"  
                                                                        />
                                                                        <span class="font-normal text-sm leading-5 text-[#171717] font-['Inter']">FlexBen Manual</span>
                                                                    </div>
                                                                    <a :href="require(`@/assets/file/HRnFLEX_FLEXBen_MSS_Manual_V4.pdf.png`)"
                                                                    download="FlexBen_Only_Admin_Manual.pdf"
                                                                    class="flex items-center justify-center gap-1 w-[94px] h-8 rounded-[8px] px-2 bg-[#4361EE] transition-colors text-[12px] font-medium leading-[100%] text-center text-white font-['Inter']">
                                                                        <img src="@/assets/img/download_icon.png" width="12" height="12" />
                                                                        Download
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                      <!-- Video Tutorials -->
                                                    <div class="flex gap-2 mt-4 mb-3">
                                                        <img src="@/assets/img/video-blue.svg" width="16" height="16" />
                                                        <span class="font-semibold text-base leading-[22px] text-[#112FBA] font-['Inter']">Video Tutorials</span>
                                                    </div>
                                                    <div class="flex flex-col gap-2 mb-10">                                                         
                                                        <template v-for="(step, index) in flexVideoTutorial" :key="index">
                                                            <!-- [S] Step-->
                                                            <div 
                                                                class="flex gap-3 mb-2"
                                                                :class="step.length > 1 ? 'items-start' : 'items-center'"                                                                
                                                            >
                                                                <span 
                                                                    class="w-14 shrink-0 text-[12px] font-semibold leading-[17px] text-[#666666] font-['Inter'] align-middle"
                                                                    :class="step.length > 1 ? 'self-start mt-2' : 'self-center'"
                                                                >
                                                                    {{ `Step${index + 1}` }}
                                                                </span>
                                                                <div class="flex flex-col gap-2">
                                                                    <template v-for="(tutorials, idx) in step" :key="idx">
                                                                        <div 
                                                                        class="flex items-center justify-between w-[296px] h-14 p-3 gap-2 rounded-xl bg-[#F4F4F4] cursor-pointer  transition-colors"
                                                                        @click="openTutorialsVideo(tutorials)">
                                                                            <div class="flex items-center gap-2">                                                    
                                                                                <img src="@/assets/img/video-gray.svg" width="24" height="24" />
                                                                                <span class="font-normal text-sm leading-5 text-[#171717] font-['Inter']"> {{ tutorials.title }}</span>
                                                                            </div>
                                                                            <span class="text-blue-500 pr-2 cursor-pointer select-none">
                                                                            ▶</span>
                                                                        </div>
                                                                </template>
                                                            </div>
                                                            </div>
                                                            <!-- [E] Step -->
                                                        </template>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { XIcon } from '@heroicons/vue/solid';

export default {
    props: {
        open: Boolean,
    },
    emits: ['update:open'],
    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        XIcon,
    },
    methods: {
        openTutorialsVideo(item) {
            window.open(item.url, item.title);
        },
        toggle(section) {
            const isOpen = this.openSections[section];

            this.openSections.coreHR = false;
            this.openSections.flexRewards = false;

            this.openSections[section] = !isOpen;
        },
    },
    data() {
        return {
            openSections: {
                coreHR: false,
                flexRewards: false,
            },
            flexVideoTutorial: [[
                    { title: 'How to Top up FlexBen points', url: 'https://drive.google.com/file/d/1F60n2GLq-WKoto9UUUy3HvJsdsYcFaP-/view?usp=sharing' },
                    { title: 'How to transfer points', url: 'https://drive.google.com/file/d/1D0_78tlpvNDh1eWpr2C18HwMer_6DZWj/view?usp=sharing' },
                    { title: 'How to transfer function', url: 'https://drive.google.com/file/d/1LakC9H-NB6pTbXKyCVWMZpnvb9TMOfT1/view?usp=sharing' },
                ],
            ],
            coreVideoTutorial: [
                [{ title: 'Join Process', url: 'https://drive.google.com/file/d/1Jk_Z-xKTgDvULdrlHWYymb47V6v-6fde/view?usp=sharing' }],
                [
                    { title: 'Company Settings', url: 'https://drive.google.com/file/d/1mzZT4wqT75VOo08xoKI1KOLkW6CUvFtT/view?usp=sharing' },
                    { title: 'How to set Work Schedule', url: 'https://drive.google.com/file/d/1o6YPPIoOGFX-qedrIbaKl_U8KsAfL6Lo/view?usp=sharing' },
                ],
                [
                    { title: 'Organization Setting', url: 'https://drive.google.com/file/d/14jaE20TtI904Er8k9kt3V-_7SxyzLI21/view?usp=sharing' },
                    { title: 'Tier', url: 'https://drive.google.com/file/d/113UwM1o0ukxQMtHfMeDnJnaB0v6VnUkW/view?usp=sharing' },
                ],
                [
                    { title: 'Attendance Setting', url: 'https://drive.google.com/file/d/10BTobY91_ggkjKeeLfBgvaPHs03OIgdl/view?usp=sharing' },
                    { title: 'How to set filing', url: 'https://drive.google.com/file/d/10qi5EFWX7OncJn60rOXEbNSk8wDRZJKd/view?usp=sharing' },
                ],
                [
                    { title: 'Invite Employees', url: 'https://drive.google.com/file/d/1YQsUiDVkWB9Nc-Mtv93z9zp3ly2oK22m/view?usp=sharing' },
                    { title: 'Invite Employees in Bulk', url: 'https://drive.google.com/file/d/1WhTcwWLnugpUwJKIlWhk9uEpj6kai7By/view?usp=sharing' },
                    { title: 'Employee Setting', url: 'https://drive.google.com/file/d/1je5w7CO-v95NJ1novCdYi0c7VOZ_Vp2y/view?usp=sharing' },
                    { title: 'Admin Settings', url: 'https://drive.google.com/file/d/1dX3I0iFUzsaUKB-WyBUemq1uoT6f1aMz/view?usp=sharing' },
                ],
                [
                    { title: 'Annual Leave Setting', url: 'https://drive.google.com/file/d/1PE3iPVKvX4Pt4AP157AGlQFprBzQ0dpV/view?usp=sharing' },
                    { title: 'Leave for Non-Regular Employees', url: 'https://drive.google.com/file/d/16xEzZHc61iqBMyhgMHFl7DobEEVSL1f_/view?usp=sharing' },
                    { title: 'Other Leave Type', url: 'https://drive.google.com/file/d/1ZKxWL9Vd6GOs3lCdPxvPt1issv5atNR6/view?usp=sharing' },
                    { title: 'Grant Leave in Bulk', url: 'https://drive.google.com/file/d/17CnUPPaQs9ZjGNlezraQqc9AvcVBbxov/view?usp=sharing' },
                ],              
                [
                    { title: 'Enter Employee Salary Information', url: 'https://drive.google.com/file/d/121pj72ww3TKMQrChzKCCSVToo1tamKAi/view?usp=sharing' },
                    { title: 'Add Payroll Template', url: 'https://drive.google.com/file/d/1-nO1fIqEGJQsW32Xe7yCH36HBNSw8mg0/view?usp=sharing' },
                    { title: 'Update Year-to-Date Payroll', url: 'https://drive.google.com/file/d/1rLpDZ_8OHEww9Yu4foRxa44Nv8-3T-bt/view?usp=sharing' },
                    { title: 'Set up Employee Loans Information', url: 'https://drive.google.com/file/d/1izXmjBBsPMF_tydgM80HRPMOXt0GpWlW/view?usp=sharing' },
                    { title: 'Payroll Processing', url: 'https://drive.google.com/file/d/1keJjE3-THPi8RIkG5g9_aXv_b3NwbEpD/view?usp=sharing' },
                    { title: 'Payslip for employees', url: 'https://drive.google.com/file/d/1D8Rq-xmZ0G1KO2cg_qNDx0nQya_3VuFd/view?usp=sharing' },
                    { title: 'Final pay', url: 'https://drive.google.com/file/d/1I9C15yr6PsvBK4nZXEm5JruQoMZiJl1i/view?usp=sharing' },
                    { title: 'Report - BIR Form 1601-C', url: 'https://drive.google.com/file/d/1Nkdybl3F95IK3v_H-MjR-hk6iwlsqUER/view?usp=sharing' },
                ],
            ],
        };
    },
};
</script>

<style scoped>
/* 스크롤 영역 */
.custom-scroll {
  scrollbar-width: thin;              
  scrollbar-color: #cfcfcf #ffffff;
}

/* Chrome, Safari */
.custom-scroll::-webkit-scrollbar {
  width: 2px !important;
}

/* 스크롤 배경 */
.custom-scroll::-webkit-scrollbar-track {
  background: #ffffff;
  border: none;
}

/* 스크롤바 */
.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #cfcfcf;
  border-radius: 9999px;
  border: none;
}

/* hover */
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #b5b5b5;
}
</style>